import React from 'react';
import NavBar from '../NavBar';
import Footer from '../Footer';
import '../../../styles/LegalPages.css';

const About = () => {
  return (
    <div className="legal-page">
      <NavBar />

      <main className="legal-container">

        {/* Hero */}
        <section className="legal-hero">
          <span className="legal-badge">ABOUT US</span>

          <h1>
            About <span>DEFilms</span>
          </h1>

          <p>
            Welcome to DEFilms, a simple and convenient platform for discovering
            movies and TV shows in one place.
          </p>
        </section>

        {/* Content */}
        <section className="legal-content">

          {/* Introduction */}
          <div className="legal-section">
            <h2>Welcome to DEFilms</h2>

            <p>
              DEFilms is a movie and TV show discovery website designed to make
              it easier for users to explore information about movies, TV
              series, genres, release dates, ratings, and other related
              information.
            </p>

            <p>
              Our goal is to provide a simple, clean, and user-friendly
              experience for visitors who want to discover something to watch.
            </p>
          </div>

          {/* What We Offer */}
          <div className="legal-section">
            <h2>What We Offer</h2>

            <p>
              DEFilms provides a variety of features designed to help users
              discover entertainment content, including:
            </p>

            <ul>
              <li>Movie and TV show information</li>
              <li>Movie and TV show search</li>
              <li>Genre and category browsing</li>
              <li>Release date information</li>
              <li>Ratings and related movie information</li>
              <li>Popular and trending content discovery</li>
              <li>A simple and responsive browsing experience</li>
            </ul>
          </div>

          {/* Our Purpose */}
          <div className="legal-section">
            <h2>Our Purpose</h2>

            <p>
              DEFilms was created with the idea of making movie discovery
              easier and more enjoyable. Instead of searching through multiple
              websites, users can explore movie and TV show information through
              a single platform.
            </p>

            <p>
              We continuously work on improving the website, its features,
              performance, and overall user experience.
            </p>
          </div>

          {/* Movie Data */}
          <div className="legal-section">
            <h2>Movie Data & Information</h2>

            <p>
              Movie and TV show information displayed on DEFilms may be
              provided through third-party movie databases and services.
            </p>

            <p>
              DEFilms does not claim ownership of third-party movie titles,
              posters, images, descriptions, trademarks, or other related
              intellectual property unless explicitly stated.
            </p>
          </div>

          {/* Third Party Services */}
          <div className="legal-section">
            <h2>Third-Party Services</h2>

            <p>
              DEFilms may use third-party services, APIs, advertising networks,
              analytics tools, or external platforms to provide certain
              features and improve the website.
            </p>

            <p>
              These third-party services may have their own terms of service
              and privacy policies. Users are encouraged to review the policies
              of those services when accessing them.
            </p>
          </div>

          {/* Free Access */}
          <div className="legal-section">
            <h2>Free Access</h2>

            <p>
              DEFilms is designed to provide visitors with easy access to movie
              and TV show information without requiring an account for basic
              browsing.
            </p>

            <p>
              Some features or services may be provided by third parties and
              may be subject to their own requirements or policies.
            </p>
          </div>

          {/* User Experience */}
          <div className="legal-section">
            <h2>User Experience</h2>

            <p>
              We aim to keep DEFilms fast, simple, and accessible across
              different devices, including desktop computers, tablets, and
              mobile phones.
            </p>

            <p>
              Website features may change, be updated, or be temporarily
              unavailable as we continue to improve the platform.
            </p>
          </div>

          {/* Contact */}
          <div className="legal-section">
            <h2>Contact Us</h2>

            <p>
              If you have questions, suggestions, copyright concerns, or other
              inquiries related to DEFilms, you can contact our team through
              the contact page.
            </p>

            <p>
              Email:{' '}
              <a
                href="mailto:admin@defilms.online"
                className="legal-contact-link"
              >
                admin@defilms.online
              </a>
            </p>
          </div>

          {/* Contact Card */}
          <div className="legal-contact-card">
            <h3>Thank You for Visiting DEFilms</h3>

            <p>
              Thank you for visiting DEFilms. We hope our platform helps you
              discover movies and TV shows that you enjoy.
            </p>

            <a href="/contact">Contact DEFilms</a>
          </div>

        </section>

        <div className="legal-updated">
          Last updated: September 21, 2026
        </div>

      </main>

      <Footer />
    </div>
  );
};

export default About;